module.exports = __webpack_public_path__ + "static/media/search-icon.c84e5f0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search-icon.svg
// module id = 1606
// module chunks = 0